// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const IconEdit: React.FC = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 12 13"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            focusable="false"
            width="24"
            height="24"
            fill="currentColor"
        >
            <path d="M11.063 1.016a1.33 1.33 0 00-1.876 0l-.562.562 2.297 2.297.562-.563a1.33 1.33 0 000-1.874l-.421-.422zM4.03 6.172c-.14.14-.234.305-.304.516L3.023 8.75c-.07.21 0 .445.141.586.164.164.375.21.586.14l2.086-.703a1.09 1.09 0 00.492-.304l3.797-3.797-2.297-2.297-3.797 3.797zM2.25 2A2.25 2.25 0 000 4.25v6a2.25 2.25 0 002.25 2.25h6a2.25 2.25 0 002.25-2.25V8a.74.74 0 00-.75-.75A.74.74 0 009 8v2.25a.74.74 0 01-.75.75h-6a.74.74 0 01-.75-.75v-6a.74.74 0 01.75-.75H4.5a.74.74 0 00.75-.75A.74.74 0 004.5 2H2.25z" />
        </svg>
    );
};

export default React.memo(IconEdit);
